import { ResourceState } from '../../types/api.js';

const isResourceStateProcessing = (state) => state && [
  ResourceState.PENDING,
  ResourceState.PROCESSING,
  "pending",
  "processing"
].includes(state);

export { isResourceStateProcessing };
//# sourceMappingURL=isResourceStateProcessing.js.map
